import { ROUTE } from "../../../routes";
import { api } from "../../../configs/api";
import { getAppHeader } from "../../../configs/config";
import { MutualAmountValueToBackend } from "../askMutualFund/types";
export const goToEmail = async (action, datastore, { navigate, network }) => {
    const userContextResponse = await network.post(api.userContext, {}, { headers: await getAppHeader() });
    const userId = userContextResponse.data.user.userId;
    await network.post(`${api.saveSecurityConsent}${userId}`, {
        consent: "YES"
    }, { headers: await getAppHeader() });
    await network.patch(`${api.userAttributes}${userId}`, {
        assetRange: MutualAmountValueToBackend.AMOUNT_0K
    }, { headers: await getAppHeader() });
    navigate(ROUTE.EMAIL_VERIFY);
};
